"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.clearRecurring = exports.setRecurring = void 0;
/**
 * Acts like setInterval, but waits for the async function to complete before
 * starting the interval.
 *
 * Ex:
 *   setRecurring(myFunc, 500):
 *   | -- execution takes 10ms -- | -- 500 ms -- | <-- total of 510 ms to next execution
 *   setInterval(myFunc, 500):
 *   | -- execution takes 10ms -- |
 *   | ------------------------- 500 ms ---- | <-- total of 500ms to next execution
 */
function setRecurring(fn, ms) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var timeout = new RecurrenceTimeoutImpl(ms, fn, args);
    return timeout.start();
}
exports.setRecurring = setRecurring;
/** Clear a recurrence started by setRecurring */
function clearRecurring(timeout) {
    if (timeout) {
        timeout.clear();
    }
}
exports.clearRecurring = clearRecurring;
var RecurrenceTimeoutImpl = /** @class */ (function () {
    function RecurrenceTimeoutImpl(interval, fn, args) {
        this.interval = interval;
        this.fn = fn;
        this.args = args;
        this.cancelled = false;
    }
    /** Clear the recurrence (stop it's next execution from happening) */
    RecurrenceTimeoutImpl.prototype.clear = function () {
        this.cancelled = true;
        if (this.latestTimeout) {
            clearTimeout(this.latestTimeout);
        }
    };
    /** Start the recurrence */
    RecurrenceTimeoutImpl.prototype.start = function () {
        var _this = this;
        if (this.latestTimeout) {
            throw new Error('Cannot start an already started recurrence');
        }
        var _a = this, fn = _a.fn, args = _a.args, interval = _a.interval;
        var wrapped = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        return [4 /*yield*/, fn.apply(void 0, args)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (!this.cancelled) {
                            this.latestTimeout = setTimeout(wrapped, interval);
                        }
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.latestTimeout = setTimeout(wrapped, interval);
        return this;
    };
    return RecurrenceTimeoutImpl;
}());
//# sourceMappingURL=recurring.js.map